import { Route, Link } from 'react-router-dom';
import { RouterUtils } from 'axway-react-ui';

// Exported BreadcrumbLink component in it's own file
// so that the hot reloader doesn't complain
export default RouterUtils.GenerateBreadcrumbLink(Route, Link);
